(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[278],{

/***/ "aSp0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Duration", function() { return Duration; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Duration = function Duration(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 500"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M250 500C112.2 500 0 387.9 0 250S112.2 0 250 0s250 112.1 250 250-112.2 250-250 250zm0-469.7C128.9 30.3 30.3 128.9 30.3 250S128.9 469.7 250 469.7 469.7 371.1 469.7 250 371.1 30.3 250 30.3z"
  }), __jsx("path", {
    d: "M246.7 268.1c-4.8 0-9.4-2.3-12.3-6.3l-99.2-137.7c-4.9-6.8-3.4-16.3 3.4-21.2 6.8-4.9 16.3-3.3 21.2 3.4l93.4 129.8 85.6-17.4c8.3-1.6 16.2 3.6 17.9 11.8 1.7 8.2-3.6 16.2-11.8 17.9l-95.2 19.3c-1 .3-2 .4-3 .4z"
  }));
};

/***/ })

}]);